import Slider from 'react-slick';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import { cn } from 'components/lib/utils';

import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';
import './style.scss';

const NextArrow = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <FontAwesomeIcon
      icon="fa-solid fa-chevron-right"
      className={cn(className, 'shadow-sm')}
      style={{ ...style, display: 'block', background: 'none' }}
      onClick={onClick}
    />
  );
};

const PrevArrow = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <FontAwesomeIcon
      icon="fa-solid fa-chevron-left"
      className={cn(className, 'shadow-sm')}
      style={{ ...style, display: 'block', background: 'none' }}
      onClick={onClick}
    />
  );
};

export const DesignPreviewSlider: React.FC<{
  assets: string[];
  setIsDragging: (isDragging: boolean) => void;
}> = ({ assets, setIsDragging }) => {
  const settings = {
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: () => {
      setIsDragging(true);
    },
    afterChange: () => {
      // small timeout so that click event after drag is ignored
      setTimeout(() => {
        setIsDragging(false);
      }, 0);
    },
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  };

  return (
    <Slider {...settings} className="template-studio-slider h-full w-full">
      {assets.map((asset) => (
        <div key={asset} className="w-full h-full">
          <img key={asset} src={asset} alt={asset} />
        </div>
      ))}
    </Slider>
  );
};
